const f = (u, n) => {
  const l = u.map((r) => r.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")).sort((r, o) => o.length - r.length);
  return n.split(/\s/).map((r) => {
    const o = l.filter(
      (t) => new RegExp(t, "i").test(r)
    );
    return o.length === 0 ? r : r.replace(
      new RegExp(o[0], "i"),
      (t) => `<strong>${t}</strong>`
    );
  }).join(" ");
}, m = (u, n) => {
  const l = u.toLowerCase().replace(/\s+/g, "");
  return n.reduce((r, o) => r + (l.includes(o) ? 1 : 0), 0);
}, h = (u, n, l = !1, r = !0) => {
  const o = u.toString().trim();
  let t = o.toLowerCase().split(/\s+/).filter((e) => e.length > 0);
  if (t.length === 0) return n;
  let g = n, p = !1;
  if (l) {
    const e = n.filter((a) => {
      const s = (a.groupName || "").toLowerCase(), i = s.replace(/\s+/g, "");
      return t.includes(s) || t.includes(i);
    });
    e?.length > 0 && (p = !0, g = e, t = t.filter(
      (a) => a !== e[0].groupName?.toLowerCase()
    ));
  }
  return t.length === 0 ? g : g.filter((e) => {
    if (!r) return !0;
    const s = `${p ? "" : (e.groupName || "").toLowerCase()} ${e.label}`.toLowerCase(), i = s.replace(/\s+/g, "");
    return t.some((c) => s.includes(c)) || t.some((c) => i.includes(c));
  }).sort((e, a) => {
    if (l && e.groupName && a.groupName) {
      if (e.groupName?.toLowerCase() < a.groupName?.toLowerCase()) return -1;
      if (e.groupName?.toLowerCase() > a.groupName?.toLowerCase()) return 1;
    }
    const s = e.label.toString().toLowerCase() === o.toLowerCase(), i = a.label.toString().toLowerCase() === o.toLowerCase();
    if (s) return -1;
    if (i) return 1;
    const c = m(e.label.toString(), t);
    return m(a.label.toString(), t) - c;
  }).map((e) => ({
    ...e,
    label: f(t, e.label.toString()),
    ariaLabel: e.ariaLabel || e.label
  }));
};
export {
  h as filteredOptions,
  m as getMatchCount,
  f as highlightSearchterm
};
